import React, { useState } from 'react'
import { connect } from 'react-redux'
import { useTranslation } from 'react-i18next'

import classNames from 'classnames'

import { GlobalOutlined } from '@ant-design/icons'
import logoSVG from 'assets/images/logo_no_icon.svg'
import helpSVG from 'assets/images/toolbar-help-24.svg'
import closeSVG from 'assets/images/toolbar-settings-24.svg'
// import FavPages from './FavPages'
// import IssuesHistory from './IssuesHistory'
// import ProjectManagement from './ProjectManagement'
import LanguageSwitcher from './LanguageSwitcher'
// import Actions from './Actions'
// import WorkspaceMenu from './WorkspaceMenu'
import UserMenu from './UserMenu'
import Settings from './Settings'
import styles from './style.module.scss'

const mapStateToProps = ({ settings, user }) => ({
  logo: settings.logo,
  authorized: user.authorized,
})

const TopBar = (props) => {
  const { logo, authorized, mode } = props
  const [settingsOpen, setSettingsOpen] = useState(false)
  const { t } = useTranslation()

  const rightComp =
    authorized === true && mode !== 'public' ? (
      <div className="">
        <React.Suspense fallback={<div>Loading...</div>}>
          <div className={classNames(styles.topBarRight)}>
            <a href="https://officemail.gitbook.io/admin" target="_blank" rel="noopener noreferrer">
              <div className={classNames('helpWrapper')}>
                <img src={helpSVG} alt="help" />
              </div>
            </a>

            <button
              type="button"
              onClick={() => setSettingsOpen(!settingsOpen)}
              className={classNames('helpWrapper', 'settingsButton')}
            >
              <img src={closeSVG} alt="settings" />
            </button>
            <Settings open={settingsOpen} onClose={() => setSettingsOpen(false)} />

            <UserMenu />
          </div>
        </React.Suspense>
      </div>
    ) : (
      <div className="mr-4 d-none d-sm-block">
        <div className="menu-language">
          <GlobalOutlined className="mr-2" />
          <span className="label">{t('topBar.profileMenu.language')} : </span>
          <LanguageSwitcher />
        </div>
      </div>
    )

  return (
    <div className={styles.topbar}>
      <div className={styles.logoContainer}>
        <div className={styles.logo}>
          <a href="/">
            <img src={logoSVG} className="mr-2" alt="Admin Console" />
          </a>
          <div className={styles.name}>{logo}</div>
          {logo === 'Clean UI Pro' && <div className={styles.descr}>React</div>}
        </div>
      </div>
      <div className="mr-auto" id="search-container" />
      {/*
      <div className="mr-4">
        <FavPages />
      </div>
      <div className="mr-auto">
        <Search />
      </div>
      <div className="mr-4 d-none d-md-block">
        <IssuesHistory />
      </div>
      <div className="mb-0 mr-auto d-xl-block d-none">
        <ProjectManagement />
      </div>
      <div className="mr-4 d-sm-block">
        <LanguageSwitcher />
      </div>
      <div className="mr-4 d-none d-sm-block">
        <Actions />
      </div>
      <div className="mr-4">
        <React.Suspense fallback={<div>Loading...</div>}>
          <WorkspaceMenu />
        </React.Suspense>
      </div>
      */}
      {rightComp}
    </div>
  )
}

export default connect(mapStateToProps)(TopBar)
